import { useAuth } from "@clerk/clerk-react";
import ClerkBillingPage from "./ClerkBillingPage";
import { StripeBillingPage } from "./StripeBillingPage";

export function BillingRouter() {
  const { has } = useAuth();
  
  // No need to manually fetch user plan - useUserPlanQuery in components 
  // automatically handles fetching with optimized caching

  if (has && (has({ plan: "pro" }) || has({ plan: "max" }))) {
    // User has a paid Clerk plan -> Show Clerk billing page
    return <ClerkBillingPage />;
  } else {
    // User is on free plan or no plan -> Show Stripe billing page
    return <StripeBillingPage />;
  }
} 